import { defaultAxios, IParams } from './base';

export interface IFetchCompanyInfo extends IParams {
  compNm: string;
  page: number;
  rowsPerPage: number;
}

export const fetchCompanyInfo = (params: any) => {
  return defaultAxios().post(`/loan/company/info`, params);
};
